if (window._0xlock !== true) {
  try {
    document.documentElement.innerHTML = "";
  } catch (e) {}
  throw new Error("Integrity check failed");
}
;
(function () {
  const _0xcacec1 = ["https://backend.ascendifytheme.com/api/validate.php", "https://backend.ascendifytheme.com/api/token.php"];
  let _0x5a78eb = false;
  if (!window.__originalFetch) {
    window.__originalFetch = window.fetch;
  }
  window.fetch = async function (_0x12f375, _0x285a9a) {
    try {
      const _0x2ccbf0 = await window.__originalFetch(_0x12f375, _0x285a9a);
      if (_0xcacec1.includes(_0x12f375)) {
        if (_0x2ccbf0.status === 403 && _0x2ccbf0.statusText === "Blocked") {
          _0x5a78eb = true;
        }
      }
      return _0x2ccbf0;
    } catch (_0x836550) {
      if (_0x836550.message.includes("blocked") || _0x836550.message.includes("Request to this API URL is blocked.")) {
        _0x5a78eb = true;
      }
      throw _0x836550;
    }
  };
  function _0x38a252(_0x3d1fc9) {
    const _0x15e13c = document.querySelector("main");
    if (_0x15e13c) {
      _0x15e13c.innerHTML = "";
      console.warn("Cleared <main> due to: " + _0x3d1fc9);
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      if (_0x5a78eb) {
        _0x38a252("Fetch override returned a fake 403 response or error");
      }
    }, 3000);
  });
})();